module.exports = __webpack_public_path__ + "static/media/20_000015.5c7309ee.jpg";